/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: auth.paths.ts
 * Project: mle-client
 * Committed last: 2021/10/25 @ 1138
 * ---
 */

export enum AuthPaths {
  LOGIN = '/auth/login',
  REGISTER = '/auth/register',
  GET_ON_BOARD = '/auth/get-on-board',
  RESET_PASSWORD = 'auth/*/reset-password'
}
